import { recordMark } from '@stitch-fix/client-analytics-reporter';
import { sendLog } from '../../utils/sendMetrics';
import mockedResponse from './useShopProductVariantBySelectedOptions.mockedResponse';
import { useGetShopProductVariantBySelectedOptionsQuery } from './getShopProductVariantBySelectedOptions';

const useShopProductVariantBySelectedOptionsQuery = ({
  skuId,
  uniqueColorId,
  inseam,
  size,
  externalProductId,
}: {
  skuId?: string | null;
  uniqueColorId?: string | null;
  inseam?: string | null;
  size?: string | null;
  externalProductId?: string | null;
}) => {
  const {
    data: shopProductVariantBySelectedOptionsData,
    loading: shopProductVariantBySelectedOptionsLoading,
    error: shopProductVariantBySelectedOptionsError,
  } = useGetShopProductVariantBySelectedOptionsQuery({
    skip: !uniqueColorId || !size || !(skuId || externalProductId),
    variables: {
      // The graphql query uses an externalProductId when this is missing.
      skuId: skuId || '',
      // The graphql query uses an skuId when this is missing.
      externalProductId: externalProductId || '',
      /* @ts-ignore skip ensures this string is present */
      uniqueColorId,
      /* @ts-ignore skip ensures this string is present */
      size,
      inseam,
      useExternalProductId: !skuId,
    },
    onCompleted: () => {
      recordMark(
        'use_shop_product_variant_by_selected_options_query_completed',
        {
          graph_query_succeeded: true,
        },
      );
    },
    onError: () => {
      recordMark(
        'use_shop_product_variant_by_selected_options_query_completed',
        {
          graph_query_succeeded: false,
        },
      );

      sendLog(
        `useGetShopProductVariantBySelectedOptionsQuery error for sku ID ${skuId}: ${shopProductVariantBySelectedOptionsError}`,
        {
          skuId,
          uniqueColorId,
          inseam,
          size,
          error_message: shopProductVariantBySelectedOptionsError,
        },
      );
    },
  });

  /* @ts-ignore no type for window */
  if (window.gon.use_mock_graphql_data) {
    return {
      shopProductVariantBySelectedOptionsData: mockedResponse.data,
      shopProductVariantBySelectedOptionsLoading,
      shopProductVariantBySelectedOptionsError,
    };
  }

  return {
    shopProductVariantBySelectedOptionsData,
    shopProductVariantBySelectedOptionsLoading,
    shopProductVariantBySelectedOptionsError,
  };
};

export default useShopProductVariantBySelectedOptionsQuery;
